import { AppFormItem, AppFormItemProps, AppInput } from 'components/atoms';

export const SimpleInputElement = ({
    disabled,
    ...restProps
}: AppFormItemProps & { placeholder?: string }) => (
    <AppFormItem disabled={disabled} {...restProps}>
        <AppInput autoComplete="off" disabled={disabled} placeholder={restProps.placeholder} />
    </AppFormItem>
);
